module.exports = __webpack_public_path__ + "img/success.eba88986.svg";